import React from "react";

import { Icon } from "@chakra-ui/react";
import {
  Home,
  Users,
  Building,
  LayoutGrid,
  UserCog,
  WashingMachine,
  LifeBuoy,
  SlidersHorizontal,
  Bell,
  Bot,
} from "lucide-react";

// User Imports
import MainDashboard from "views/user/default";
import UserSettings from "views/user/settings";
import UserManagement from "views/user/user-management/main";
import PropertyManagement from "views/user/property-management/main";
import PropertyBoard from "views/user/property-management/view/global";
import PropertyDetail from "views/user/property-management/view/main";
import LaundryCreateNew from "views/user/laundry-management/create-new";
import LaundrySettings from "views/user/laundry-management/settings";
import Notifications from "views/user/notifications";
import Support from "views/user/support";
import AiAgentTestNumbers from "views/user/ai-agent/test-numbers";
import AppSettingsGeneral from "views/user/app-settings/general";
import AppSettingsIntegrations from "views/user/app-settings/integrations";

// Auth Imports
import SignInCentered from "views/auth/signIn";
import PrivacyPolicy from "views/auth/privacy-policy";

const routes = [
  {
    type: "sidebarItem",
    name: "Dashboard",
    roles: ["admin","office","operation","maintenance","cleaner"],
    layout: "/user",
    path: "/dashboard",
    icon: <Icon as={Home} width='20px' height='20px' color='inherit' />,
    component: MainDashboard,
  },
  {
    type: "sidebarItem",
    name: "Team",
    roles: ["admin"],
    layout: "/user",
    path: "/team/management",
    icon: <Icon as={Users} width='20px' height='20px' color='inherit' />,
    component: UserManagement,
  },
  {
    type: "sidebarItem",
    name: "Proprietà",
    roles: ["admin","office"],
    layout: "/user",
    path: "/property/management",
    icon: <Icon as={Building} width='20px' height='20px' color='inherit' />,
    component: PropertyManagement,
  },
  {
    type: "sidebarItem",
    name: "Bacheca Proprietà",
    layout: "/user",
    path: "/property/board",
    icon: <Icon as={LayoutGrid} width='20px' height='20px' color='inherit'/>,
    roles: ["admin","office","operation","maintenance","cleaner"],
    component: PropertyBoard,
  },
  {
    type: "sidebarItem",
    name: "Notifiche",
    layout: "/user",
    path: "/notifications",
    icon: <Icon as={Bell} width='20px' height='20px' color='inherit' />,
    roles: ["admin", "office"],
    component: Notifications,
  },
  {
    type: "sidebarDropdown",
    name: "Lavanderia",
    roles: ["admin", "office", "operation", "maintenance", "cleaner"],
    icon: <Icon as={WashingMachine} width='20px' height='20px' color='inherit' />,
    items: [
      {
        name: "Crea Nuovo",
        layout: "/user",
        path: "/laundry/create",
        roles: ["admin", "office", "operation", "maintenance", "cleaner"],
        component: LaundryCreateNew,
      },
      {
        name: "Strumenti",
        layout: "/user",
        path: "/laundry/tools",
        roles: ["admin", "office", "operation", "maintenance", "cleaner"],
        component: LaundrySettings,
      },
    ],
  },
  {
    type: "sidebarItem",
    name: "Assistenza",
    layout: "/user",
    path: "/support",
    roles: ["admin", "office", "operation"],
    // Stays visible while the AI is off if test numbers can still hand off to a human
    settingRequired: "whatsapp_support_visible",
    icon: <Icon as={LifeBuoy} width='20px' height='20px' color='inherit' />,
    component: Support,
  },
  {
    type: "sidebarDropdown",
    name: "Agente AI",
    roles: ["admin"],
    icon: <Icon as={Bot} width='20px' height='20px' color='inherit' />,
    items: [
      {
        name: "Numeri di Test",
        layout: "/user",
        path: "/ai-agent/test-numbers",
        roles: ["admin"],
        component: AiAgentTestNumbers,
      },
    ],
  },
  {
    type: "sidebarDropdown",
    name: "Impostazioni App",
    roles: ["admin"],
    icon: <Icon as={SlidersHorizontal} width='20px' height='20px' color='inherit' />,
    items: [
      {
        name: "Generali",
        layout: "/user",
        path: "/app-settings/general",
        roles: ["admin"],
        component: AppSettingsGeneral,
      },
      {
        name: "Integrazioni",
        layout: "/user",
        path: "/app-settings/integrations",
        roles: ["admin"],
        component: AppSettingsIntegrations,
      },
    ],
  },
  {
    type: "sidebarItem",
    name: "Account",
    layout: "/user",
    path: "/settings",
    roles: ["admin", "office", "operation", "maintenance","cleaner"],
    class:"last-item",
    icon: <Icon as={UserCog} width='20px' height='20px' color='inherit' />,
    component: UserSettings,
  },
  {
    type: "independentItem",
    name: "Accedi",
    layout: "/auth",
    path: "/login",
    roles: ["admin"],
    component: SignInCentered,
  },
  {
    type: "independentItem",
    name: "Informativa Privacy",
    layout: "/auth",
    path: "/privacy-policy",
    roles: ["admin"],
    component: PrivacyPolicy,
  },
  {
    type: "independentItem",
    name: "Impostazioni",
    layout: "/user",
    path: "/settings",
    roles: ["admin"],
    component: UserSettings,
  },
  {
    type: "independentItem",
    name: "Dettaglio Proprietà",
    layout: "/user",
    roles: ["admin", "office", "operation", "maintenance"],
    path: "/property/management/view/:id",
    component: PropertyDetail,
  },
];

export default routes;
